import React from 'react';
import './Preloader.css';

const Preloader = () => {
  return (
    <div className="loader-container">
        <div className="loader"></div>
    </div>
  );
};

export default Preloader;
